import Vue from 'vue'
import Router from 'vue-router'

import store from './store'

import Base from './views/Base.vue'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import ResetPassword from './views/ResetPassword.vue'
import Impostazioni from './views/Impostazioni.vue'

import InstallatoriList from './views/installatori/list.vue'
import InstallatoriAdd from './views/installatori/add.vue'
import InstallatoriEdit from './views/installatori/edit.vue'
import InstallatoriManager from './views/installatori/manager.vue'

import ClientiList from './views/clienti/list.vue'
import ClientiAdd from './views/clienti/add.vue'
import ClientiEdit from './views/clienti/edit.vue'

import ElencoMarche from './views/elenco/list/Marche.vue'
import ElencoMarcheAdd from './views/elenco/add/Marche.vue'
import ElencoMarcheEdit from './views/elenco/edit/Marche.vue'

import ElencoCostruttori from './views/elenco/list/Costruttori.vue'
import ElencoCostruttoriAdd from './views/elenco/add/Costruttori.vue'
import ElencoCostruttoriEdit from './views/elenco/edit/Costruttori.vue'

import ElencoComponenti from './views/elenco/list/Componenti.vue'
import ElencoComponentiAdd from './views/elenco/add/Componenti.vue'
import ElencoComponentiEdit from './views/elenco/edit/Componenti.vue'
import ElencoComponentiImport from './views/elenco/import/Componenti.vue'

import ElencoTipoElettrico from './views/elenco/list/Tipoelettrico.vue'
import ElencoTipoElettricoAdd from './views/elenco/add/Tipoelettrico.vue'
import ElencoTipoElettricoEdit from './views/elenco/edit/Tipoelettrico.vue'

import ElencoTipoComponente from './views/elenco/list/Tipocomponente.vue'
import ElencoTipoComponenteAdd from './views/elenco/add/Tipocomponente.vue'
import ElencoTipoComponenteEdit from './views/elenco/edit/Tipocomponente.vue'

import ElencoSottotipoComponente from './views/elenco/list/Sottotipocomponente.vue'
import ElencoSottotipoComponenteAdd from './views/elenco/add/Sottotipocomponente.vue'
import ElencoSottotipoComponenteEdit from './views/elenco/edit/Sottotipocomponente.vue'

import ElencoTipoManufatto from './views/elenco/list/Tipomanufatto.vue'
import ElencoTipoManufattoAdd from './views/elenco/add/Tipomanufatto.vue'
import ElencoTipoManufattoEdit from './views/elenco/edit/Tipomanufatto.vue'

import ElencoTipoUtilizzo from './views/elenco/list/Tipoutilizzo.vue'
import ElencoTipoUtilizzoAdd from './views/elenco/add/Tipoutilizzo.vue'
import ElencoTipoUtilizzoEdit from './views/elenco/edit/Tipoutilizzo.vue'

import ElencoTipoUso from './views/elenco/list/Tipouso.vue'
import ElencoTipoUsoAdd from './views/elenco/add/Tipouso.vue'
import ElencoTipoUsoEdit from './views/elenco/edit/Tipouso.vue'

import ElencoTipoTamponamento from './views/elenco/list/Tipotamponamento.vue'
import ElencoTipoTamponamentoAdd from './views/elenco/add/Tipotamponamento.vue'
import ElencoTipoTamponamentoEdit from './views/elenco/edit/Tipotamponamento.vue'

import ElencoTipoCliente from './views/elenco/list/Tipocliente.vue'
import ElencoTipoClienteAdd from './views/elenco/add/Tipocliente.vue'
import ElencoTipoClienteEdit from './views/elenco/edit/Tipocliente.vue'

import ElencoTipoLuogo from './views/elenco/list/Tipoluogo.vue'
import ElencoTipoLuogoAdd from './views/elenco/add/Tipoluogo.vue'
import ElencoTipoLuogoEdit from './views/elenco/edit/Tipoluogo.vue'

import ElencoTipoMacchina from './views/elenco/list/Tipomacchina.vue'
import ElencoTipoMacchinaAdd from './views/elenco/add/Tipomacchina.vue'
import ElencoTipoMacchinaEdit from './views/elenco/edit/Tipomacchina.vue'

import MacchineList from './views/macchine/list.vue'
import MacchineAdd from './views/macchine/add.vue'
import MacchineEdit from './views/macchine/edit.vue'
import MacchinePacchetti from './views/macchine/pacchetti.vue'

import AdminModelliAdd from './views/admin/add/Modelli.vue'
import AdminModelli from './views/admin/list/Modelli.vue'
import AdminModelliEdit from './views/admin/edit/Modelli.vue'

import UtentiInstallatori from './views/utenti/list/Installatori.vue'
import UtentiInstallatoriView from './views/utenti/view/Installatori.vue'

import UtentiConsulenti from './views/utenti/list/Consulenti.vue'
import UtentiConsulentiView from './views/utenti/view/Consulenti.vue'

import UtentiAziende from './views/utenti/list/Aziende.vue'
import UtentiAziendeAdd from './views/utenti/add/Aziende.vue'
import UtentiAziendeView from './views/utenti/view/Aziende.vue'

async function isLogged (to, from, next) {
  await store.dispatch('updateUserStatus')
  if(store.getters.stato.installatore || store.getters.stato.consulente){
    if(to.name != 'login'){
      next()
      return
    }
    next('/')
    /*if(response.body.reset){
      next('/resetpassword')
      return
    }else{*/
    //}
  }else
    next('/login')
}

/*function isLoggedAdmin (to, from, next) {
  Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
    if(response.body.success){
      Vue.prototype.$isAdmin = response.body.isAdmin
      if(to.name != 'login' && response.body.isAdmin){
        next()
        return
      }
      next('/')
      return
    }
    Vue.prototype.$isAdmin = false
    next('/login')
  }, response => {
    next('/login')
  })
}*/

async function isNotLogged (to, from, next) {
  await store.dispatch('updateUserStatus')
  if(store.getters.stato.installatore || store.getters.stato.consulente){
    next('/')
  }else
    next()
}

async function isAdmin (to, from, next) {
  await store.dispatch('updateUserStatus')
  if(store.getters.stato.admin){
    next()
  }else
    next('/')
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: isNotLogged
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: ResetPassword,
      beforeEnter: isNotLogged
    },
    {
      path: '/',
      component: Base,
      beforeEnter: isLogged,
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'impostazioni',
          name: 'impostazioni',
          component: Impostazioni
        },
        /*INSTALLATORI*/
        {
          path: 'installatori',
          name: 'installatorilist',
          component: InstallatoriList
        },
        {
          path: 'installatori/aggiungi',
          name: 'installatoriadd',
          component: InstallatoriAdd
        },
        {
          path: 'installatori/modifica/:id',
          name: 'installatorimodify',
          component: InstallatoriEdit
        },
        {
          path: 'installatori/gestisci',
          name: 'installatorimanager',
          component: InstallatoriManager
        },


        /*CLIENTI*/
        {
          path: 'clienti',
          name: 'clientilist',
          component: ClientiList
        },
        {
          path: 'clienti/aggiungi',
          name: 'clientiadd',
          component: ClientiAdd
        },
        {
          path: 'clienti/modifica/:id',
          name: 'clientimodify',
          component: ClientiEdit
        },

        /*ELENCO*/
        //marche
        {
          path: 'elenco/marche',
          name: 'elencomarche',
          component: ElencoMarche
        },
        {
          path: 'elenco/marche/aggiungi',
          name: 'elencomarcheadd',
          component: ElencoMarcheAdd
        },
        {
          path: 'elenco/marche/modifica/:id',
          name: 'elencomarcheedit',
          component: ElencoMarcheEdit
        },

        //costruttori
        {
          path: 'elenco/costruttori',
          name: 'elencocostruttori',
          component: ElencoCostruttori
        },
        {
          path: 'elenco/costruttori/aggiungi',
          name: 'elencocostruttoriadd',
          component: ElencoCostruttoriAdd
        },
        {
          path: 'elenco/costruttori/modifica/:id',
          name: 'elencocostruttoriedit',
          component: ElencoCostruttoriEdit
        },

        //componenti
        {
          path: 'elenco/componenti',
          name: 'elencocomponenti',
          component: ElencoComponenti
        },
        {
          path: 'elenco/componenti/aggiungi',
          name: 'elencocomponentiadd',
          component: ElencoComponentiAdd
        },
        {
          path: 'elenco/componenti/aggiungi/:option',
          name: 'elencocomponentiaddoption',
          component: ElencoComponentiAdd
        },
        {
          path: 'elenco/componenti/modifica/:id',
          name: 'elencocomponentiedit',
          component: ElencoComponentiEdit
        },
        {
          path: 'elenco/componenti/importa',
          name: 'elencocomponentiimport',
          component: ElencoComponentiImport
        },

        //tipo elettrico
        {
          path: 'elenco/tipoelettrico',
          name: 'elencotipoelettrico',
          component: ElencoTipoElettrico
        },
        {
          path: 'elenco/tipoelettrico/aggiungi',
          name: 'elencotipoelettricoadd',
          component: ElencoTipoElettricoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipoelettrico/modifica/:id',
          name: 'elencotipoelettricoedit',
          component: ElencoTipoElettricoEdit,
          beforeEnter: isAdmin
        },

        //tipo componente
        {
          path: 'elenco/tipocomponente',
          name: 'elencotipocomponente',
          component: ElencoTipoComponente
        },
        {
          path: 'elenco/tipocomponente/aggiungi',
          name: 'elencotipocomponenteadd',
          component: ElencoTipoComponenteAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipocomponente/modifica/:id',
          name: 'elencotipocomponenteedit',
          component: ElencoTipoComponenteEdit,
          beforeEnter: isAdmin
        },

        //sottotipo componente
        {
          path: 'elenco/sottotipocomponente',
          name: 'elencosottotipocomponente',
          component: ElencoSottotipoComponente
        },
        {
          path: 'elenco/sottotipocomponente/aggiungi',
          name: 'elencosottotipocomponenteadd',
          component: ElencoSottotipoComponenteAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/sottotipocomponente/modifica/:id',
          name: 'elencosottotipocomponenteedit',
          component: ElencoSottotipoComponenteEdit,
          beforeEnter: isAdmin
        },

        //tipo manufatto
        {
          path: 'elenco/tipomanufatto',
          name: 'elencotipomanufatto',
          component: ElencoTipoManufatto
        },
        {
          path: 'elenco/tipomanufatto/aggiungi',
          name: 'elencotipomanufattoadd',
          component: ElencoTipoManufattoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipomanufatto/modifica/:id',
          name: 'elencotipomanufattoedit',
          component: ElencoTipoManufattoEdit,
          beforeEnter: isAdmin
        },

        //tipo utilizzo
        {
          path: 'elenco/tipoutilizzo',
          name: 'elencotipoutilizzo',
          component: ElencoTipoUtilizzo
        },
        {
          path: 'elenco/tipoutilizzo/aggiungi',
          name: 'elencotipoutilizzoadd',
          component: ElencoTipoUtilizzoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipoutilizzo/modifica/:id',
          name: 'elencotipoutilizzoedit',
          component: ElencoTipoUtilizzoEdit,
          beforeEnter: isAdmin
        },

        //tipo uso
        {
          path: 'elenco/tipouso',
          name: 'elencotipouso',
          component: ElencoTipoUso
        },
        {
          path: 'elenco/tipouso/aggiungi',
          name: 'elencotipousoadd',
          component: ElencoTipoUsoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipouso/modifica/:id',
          name: 'elencotipousoedit',
          component: ElencoTipoUsoEdit,
          beforeEnter: isAdmin
        },

        //tipo tamponamento
        {
          path: 'elenco/tipotamponamento',
          name: 'elencotipotamponamento',
          component: ElencoTipoTamponamento
        },
        {
          path: 'elenco/tipotamponamento/aggiungi',
          name: 'elencotipotamponamentoadd',
          component: ElencoTipoTamponamentoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipotamponamento/modifica/:id',
          name: 'elencotipotamponamentoedit',
          component: ElencoTipoTamponamentoEdit,
          beforeEnter: isAdmin
        },

        //tipo cliente
        {
          path: 'elenco/tipocliente',
          name: 'elencotipocliente',
          component: ElencoTipoCliente
        },
        {
          path: 'elenco/tipocliente/aggiungi',
          name: 'elencotipoclienteadd',
          component: ElencoTipoClienteAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipocliente/modifica/:id',
          name: 'elencotipoclienteedit',
          component: ElencoTipoClienteEdit,
          beforeEnter: isAdmin
        },

        //tipo luogo
        {
          path: 'elenco/tipoluogo',
          name: 'elencotipoluogo',
          component: ElencoTipoLuogo
        },
        {
          path: 'elenco/tipoluogo/aggiungi',
          name: 'elencotipoluogoadd',
          component: ElencoTipoLuogoAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipoluogo/modifica/:id',
          name: 'elencotipoluogoedit',
          component: ElencoTipoLuogoEdit,
          beforeEnter: isAdmin
        },

        //tipo macchina
        {
          path: 'elenco/tipomacchina',
          name: 'elencotipomacchina',
          component: ElencoTipoMacchina
        },
        {
          path: 'elenco/tipomacchina/aggiungi',
          name: 'elencotipomacchinaadd',
          component: ElencoTipoMacchinaAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'elenco/tipomacchina/modifica/:id',
          name: 'elencotipomacchinaedit',
          component: ElencoTipoMacchinaEdit,
          beforeEnter: isAdmin
        },

        /*MACCHINA*/
        {
          path: 'macchine',
          name: 'macchinelist',
          component: MacchineList
        },
        {
          path: 'macchine/aggiungi',
          name: 'macchineadd',
          component: MacchineAdd
        },
        {
          path: 'macchine/modifica/:id',
          name: 'macchinemodify',
          component: MacchineEdit
        },
        {
          path: 'macchine/modifica/:id/:page',
          name: 'macchinemodifypage',
          component: MacchineEdit
        },
        {
          path: 'macchine/pacchetti/:id',
          name: 'macchinepacchetti',
          component: MacchinePacchetti
        },

        /*ADMIN*/
        {
          path: 'admin/modelli',
          name: 'adminmodelli',
          component: AdminModelli,
          beforeEnter: isAdmin
        },
        {
          path: 'admin/modelli/aggiungi',
          name: 'adminmodelliadd',
          component: AdminModelliAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'admin/modelli/modifica/:id',
          name: 'adminmodelliedit',
          component: AdminModelliEdit,
          beforeEnter: isAdmin
        },

        /*UTENTI*/
        //installatori
        {
          path: 'utenti/installatori/',
          name: 'utentiinstallatori',
          component: UtentiInstallatori,
          beforeEnter: isAdmin
        },
        {
          path: 'utenti/installatori/visualizza/:id',
          name: 'utentiinstallatoriview',
          component: UtentiInstallatoriView,
          beforeEnter: isAdmin
        },
        //consulenti
        {
          path: 'utenti/consulenti/',
          name: 'utenticonsulenti',
          component: UtentiConsulenti,
          beforeEnter: isAdmin
        },
        {
          path: 'utenti/consulenti/visualizza/:id',
          name: 'utenticonsulentiview',
          component: UtentiConsulentiView,
          beforeEnter: isAdmin
        },
        //aziende
        {
          path: 'utenti/aziende/',
          name: 'utentiaziende',
          component: UtentiAziende,
          beforeEnter: isAdmin
        },
        {
          path: 'utenti/aziende/aggiungi',
          name: 'utentiaziendeadd',
          component: UtentiAziendeAdd,
          beforeEnter: isAdmin
        },
        {
          path: 'utenti/aziende/visualizza/:id',
          name: 'utentiaziendeview',
          component: UtentiAziendeView,
          beforeEnter: isAdmin
        }
      ]
    },
    /* REDIRECT PAGE NOT FOUND */
    { 
      path: "*", 
      redirect: '/login'
    }
  ]
})
